/**
 * Parcels Details
 */

// React
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';



//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import theme from '../../theme';
import {
  Dialog,
  DialogActions,
  Grid,
  Button,
  Divider,
  CircularProgress,
  Select,
  FormControl,
  IconButton,
  MenuItem,
  DialogTitle,
  TextField,
  FormHelperText,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiClose,
  mdiCheck,
  mdiPackageVariantClosed,
  mdiFileTree,
  mdiBarcodeScan,
} from '@mdi/js';

// Components
import ListParcelItems from './listMob';
import InventoryItemsList from './inventoryItemsListMob';

// Type
import { Props, Product } from './interfaces';
import Pagination from '@material-ui/lab/Pagination';
import Modal from '../../components/Modal';
import { useForm } from 'react-hook-form';
import { InventoryItem } from '../orderPack/interfaces';
import parcelsRepository from "client-sdk/src/Repository/parcels-repository";
import inventoryItemsRepository from "client-sdk/src/Repository/inventory-items-repository";
import handleError from "../../utils/handleError";
import handleNotfication from "../../utils/handleNotification";

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '16px',
      marginBottom: '16px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    allocateIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingTop: '10px',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    collapseIcon: {
      marginTop: '-36px',
      textAlign: 'center',
      position: 'relative',
      width: '100%',
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '40px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: theme.palette.secondary.main,
        border: '5px solid white',
      },
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      marginTop: '24px',
      fontSize: '12px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    showCount: {
      '& .MuiSelect-icon': {
        color: '#DFA01F',
      },
    },
    card: {
      width: '100%',
      display: 'flex',
      background: '#fff',
      padding: '8px 4px',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    cardItem: {
      margin: '0 4px',
      flex: 1,
    },
    btnBottom: {
      flexDirection: 'row',
      position: 'fixed',
      width: '100%',
      backgroundColor: '#fff',
      bottom: '0',
      right: '0',
      padding: '15px 10px',
      zIndex: 2,
      borderTop: '1px solid lightgray',
    }
  }),
);

export function Details(props: Props) {
  const history = useHistory();
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [openItemsNotFound, setOpenItemsNotFound] = useState(false as boolean);
  const [openBarcode, setOpenBarcode] = useState(false as boolean);
  const [openBarcodeSerial, setOpenBarcodeSerial] = useState(false as boolean);
  const [barcodeModalChanged, setBarcodeModalChanged] = useState(
    false as boolean,
  );
  const [checkBarcodeDialogClosed, setCheckBarcodeDialogClosed] = useState(
    false as boolean,
  );
  const [
    openDialogForChangeParcelStatus,
    setOpenDialogForChangeParcelStatus,
  ] = useState(false as boolean);
  const [
    openDialogForItemsNotRegistered,
    setOpenDialogForItemsNotRegistered,
  ] = useState(false as boolean);
  const [openRegisterItems, setOpenRegisterItems] = useState(false as boolean);
  const [openLocatingItems, setOpenLocatingItems] = useState(false as boolean);
  const [openItemHasAlreadyLocated, setOpenItemHasAlreadyLocated] = useState(false as boolean);
  const { handleSubmit, register, watch, errors } = useForm();
  const [id, setId] = useState(-1 as number);
  const [serial, setSerial] = useState('');
  const [description, setDescription] = useState('');
  const [inventoryItems, setInventoryItems] = useState([] as any[]);
  const [barcode, setBarcode] = useState('');
  const [product, setProduct] = useState({} as Product);
  const [unit, setUnit] = useState('');
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 100,
  } as any);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [error, setError] = useState("");
  const [inventoryItemsError, setInventoryItemsError] = useState("");
  const [
    inventoryItemsWithStatusError,
    setInventoryItemsWithStatusError
  ] = useState("");
  const [loading, setLoading] = useState(false);
  const [inventoryItemsLoading, setInventoryItemsLoading] = useState(false);
  const [
    inventoryItemsWithStatusLoading,
    setInventoryItemsWithStatusLoading
  ] = useState(false);
  const [parcel, setParcel] = useState({});
  const [inventoryItem, setInventoryItem] = useState([]);
  const [
    inventoryItemsWithSerialError,
    setInventoryItemsWithSerialError
  ] = useState("");
  const [
    inventoryItemsWithSerialLoading,
    setInventoryItemsWithSerialLoading
  ] = useState(false);
  const [inventoryItemsWithSerial, setInventoryItemsWithSerial] = useState(
    []
  );
  const [inventoryItemsWithStatus, setInventoryItemsWithStatus] = useState(
    []
  );
  const [inventoryItemsCount, setInventoryItemsCount] = useState(0);
  const handleCollapse = () => {
    setOpen(!open);
  };

  const handleCloseSelect = () => {
    setOpenSize(false);
  };

  const handleCloseDialogForItemsNotRegistered = () => {
    setOpenDialogForItemsNotRegistered(false);
  };

  const setOpenBarcodeFunc = (product: Product) => {
    setId(product.id);
    setOpenBarcode(true);
  };

  const handleCloseDialogForChangeParcelStatus = () => {
    setOpenDialogForChangeParcelStatus(false);
  };
  const updateParcelsStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const callback = await parcelsRepository.updateParcelStatus({
        payload
      });
      handleNotfication("محموله با موفقیت به روز رسانی شد", "success");
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  };
  const handleSetParcelStatus = async (status: string) => {
    if (status === 'LOCATED') setDescription('');
    await updateParcelsStatus({
      id: props.match.params.id,
      body: { status: status.replace(/'/g, '"'), description: description },
      pagination: {
        ...filtersValues,
      },
      callback: () => {
        history.push('/parcels-warehouse-operator-mob');
      },
    });
    setOpenDialogForItemsNotRegistered(false);
    setOpenDialogForChangeParcelStatus(false);
  };

  const handleOpenConfirmDisable = (item: Product) => {
    setOpenRegisterItems(true);
    setId(item.id);
    setProduct(item);
  };

  const checkBarcode = async () => {
    setCheckBarcodeDialogClosed(true);
    setBarcodeModalChanged(!barcodeModalChanged);
  };
  const getInventoryItemsWithSerial = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsWithSerialLoading(true);
      const {
        response,
        callback
      } = await inventoryItemsRepository.getInventoryItemsWithSerial(
        { payload },
        payload.callback
      );
      setInventoryItemsWithSerial(response.data.content);
      if (callback) {
        callback();
      }
      if (response.data.content.length === 0)
        handleNotfication("هیچ آیتمی پیدا نشد.", "warn");
    } catch (error) {
      setInventoryItemsWithSerialError(error.message);
      handleError(error.response);
    } finally {
      setInventoryItemsWithSerialLoading(false);
    }
  };
  const getParcelInventoryItems = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsLoading(true);
      const {
        response,
        callback
      } = await inventoryItemsRepository.getParcelInventoryItems({ payload });
      setInventoryItem(response.data.content);
      setInventoryItemsCount(response.data.totalElements);
      if (callback) {
        callback();
      }
    } catch (error) {
      setInventoryItemsError(error.message);
      handleError(error.response);
    } finally {
      setInventoryItemsLoading(false);
    }
  };

  const updateInventoryItemsStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const callback = await inventoryItemsRepository.locateInventoryItemsUnit({
        payload
      });
      handleNotfication(
        "وضعیت آیتم مورد نظر با موفقیت تغییر کرد ",
        "success"
      );
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  };
  const checkSerialFunc = ({ serial }: { serial: string }) => {
    updateInventoryItemsStatus({
      id: id !== -1 ? id : inventoryItemsWithSerial[0]?.id,
      body: { barcode: parseInt(serial) },
      ...filtersValues,
      callback: () => {
        getParcelInventoryItems({
          ...filtersValues,
          "status.equals": undefined,
          parcelId: { equals: props.match.params.id }
        });
        // setLoading(false);
        setOpenBarcode(false);
      }
    });
    setSerial('');
    setOpenRegisterItems(false);
  };
  const handleAllocateUserFunc = () => {
    updateInventoryItemsStatus({
      id: id !== -1 ? id : inventoryItemsWithSerial[0]?.id,
      body: { barcode: parseInt(unit) },
      ...filtersValues,
      callback: () => {
        //
      }
    });
    setOpenLocatingItems(false);
    setOpenRegisterItems(false);
  };

  const handleAllocateAllItemsUserFunc = () => {
    handleAllocateAllItemsUser();
  };
  const updateAllInventoryItemsStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const callback = await inventoryItemsRepository.locateAllInventoryItemsUnit(
        { payload }
      );
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  }
  const handleAllocateAllItemsUser = () => {
    const inventoryItemsIds = inventoryItems.map(
      (inventoryItem: any) => inventoryItem.id,
    );
    updateAllInventoryItemsStatus({
      body: {
        barcode: unit,
        ids: inventoryItemsIds
      },
      ...filtersValues,
      callback: () => {
        handleNotfication("جایگذاری با موفقیت انجام شد.", "success")
        getParcelInventoryItems({
          ...filtersValues,
          parcelId: { equals: props.match.params.id }
        });
        setOpenLocatingItems(false);
        setOpenRegisterItems(false);
        setOpenBarcodeSerial(false)
        setInventoryItems([]);
      },
    });
  };

  const getInventoryItemsWithStatus = () => {
    const findNotLocated = inventoryItem.filter((el: InventoryItem) => (el.status !== 'LOCATED' && el.status !== 'CHECKED' && el.status !== 'PICKED'));
    if (findNotLocated?.length) {
      setOpenDialogForItemsNotRegistered(true);
      return;
    }
    setOpenDialogForChangeParcelStatus(true);
  };

  const handleCloseItemHasAlreadyLocated = () => {
    setOpenItemHasAlreadyLocated(false);
    setBarcode('');
  };
  const cleanInventoryItems = () => {
    setInventoryItemsError("");
    setInventoryItemsCount(0);
    setInventoryItems([]);
  }
  useEffect(() => {
    return () => {
      cleanInventoryItems();
    };
  }, []);

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number,
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };
  const getParcelWithId = async (id: any) => {
    const payload = { id };
    try {
      setLoading(true);
      const response = await parcelsRepository.getParcelsWithId({ payload });
      setParcel(response.data);
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const { id } = props.match.params;
    getParcelWithId(id);
    getParcelInventoryItems({
      ...filtersValues,
      parcelId: { equals: id }
    });
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (checkBarcodeDialogClosed) handleCloseBarcodeSerial(true);
  }, [barcodeModalChanged]);

  useEffect(() => {
    if (inventoryItemsWithSerial.length !== 0) {
      setBarcode('');
      const oldInventoryItem = inventoryItems.filter(
        item =>
          inventoryItemsWithSerial[0].serialNumber === item.serialNumber,
      );
      if (
        oldInventoryItem.length === 0 &&
        inventoryItemsWithSerial[0]?.status !== 'LOCATED'
      )
        setInventoryItems([
          ...inventoryItems,
          inventoryItemsWithSerial[0],
        ]);
      if (inventoryItemsWithSerial[0]?.status === 'LOCATED') {
        setOpenItemHasAlreadyLocated(true);
      }
    }
  }, [inventoryItemsWithSerial]);


  const handleClose = () => {
    setOpenRegisterItems(false);
    setOpenLocatingItems(false);
  };

  const handleCloseItemsNotFound = () => {
    setOpenItemsNotFound(false);
  };

  const handleBarcode = (value: string) => {
    setBarcode(value);
  };

  const removeItem = (itemDeleted: any) => {
    const newValue = inventoryItems.filter(
      (item: any) => item.id !== itemDeleted.id
    );
    setInventoryItems(newValue);
  }

  const handleCloseBarcode = (setRegistered: boolean) => {
    setOpenBarcode(false);
    if (setRegistered && inventoryItemsWithSerial.length !== 0) {
      setId(-1);
      setOpenRegisterItems(true);
    } else if (setRegistered && inventoryItemsWithSerial.length === 0) {
      setOpenItemsNotFound(true);
    }
  };

  const handleCloseBarcodeSerial = (setRegistered: boolean) => {
    if (setRegistered && inventoryItemsWithSerial.length !== 0) {
      setId(-1);
      setOpenLocatingItems(true);
    } else if (setRegistered && inventoryItemsWithSerial.length === 0) {
      setOpenItemsNotFound(true);
    }
  };

  const handleChangePageNum = (pageNumber: number) => {
    setFiltersValues({ ...filtersValues, page: pageNumber });
  };

  const handleFilterStatus = (status: string) => {
    if (filtersValues?.['status.equals'] === status) {
      setFiltersValues((prevState: any) => ({
        ...prevState, 'status.equals': undefined,
      }));
      return;
    }
    setFiltersValues((prevState: any) => ({
      ...prevState, 'status.equals': status,
    }));
  };

  return (
    <div className={classes.root}>
      <Grid style={{ marginTop: '30px', marginBottom: '8px' }} container alignItems='center' justify="space-between">
        <BarcodeForm
          id={props.match.params.id}
          inventoryItemsWithSerial={inventoryItemsWithSerial}
          getInventoryItemsWithSerialActionDispatch={
            getInventoryItemsWithSerial
          }
          inventoryItemsWithSerialLoading={
            inventoryItemsWithSerialLoading
          }
          setModal={setOpenBarcodeSerial}
        />
        <div className={classes.card}>

          <div className={classes.cardItem}>
            {filtersValues?.status}
            <Button
              color="secondary"
              size="medium"
              fullWidth
              variant={
                filtersValues?.['status.equals'] !== 'REGISTERED' &&
                  filtersValues?.['status.equals'] !== 'LOCATED' ? 'contained' : 'outlined'
              }
              onClick={() => {
                handleFilterStatus('');
              }}

            >
              همه
            </Button>
          </div>
          <div className={classes.cardItem}>
            {filtersValues?.status}
            <Button
              fullWidth
              color="secondary"
              size="medium"
              variant={filtersValues?.['status.equals'] === 'REGISTERED' ? 'contained' : 'outlined'}
              onClick={() => {
                handleFilterStatus('REGISTERED');
              }}
            >
              جایگذاری نشده
            </Button>
          </div>
          <div className={classes.cardItem}>
            <Button
              fullWidth
              color="secondary"
              size="medium"
              variant={filtersValues?.['status.equals'] === 'LOCATED' ? 'contained' : 'outlined'}
              onClick={() => {
                handleFilterStatus('LOCATED');
              }}

            >
              جایگذاری شده
            </Button>
          </div>
        </div>

      </Grid>
      <Grid container >
        <Grid item xs={12} >
          {inventoryItemsLoading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            inventoryItem && (
              <ListParcelItems
                operatorId={parcel.operatorId}
                handleOpenConfirmDisable={handleOpenConfirmDisable}
                setOpenBarcode={setOpenBarcodeFunc}
                data={inventoryItem}
              />
            )
          )}
        </Grid>
        <Grid id="showFilter" item xs={12} sm={12} container style={{ marginTop: '16px', marginBottom: '24px', justifyContent: 'space-between' }}>
          <Grid sm={6}>
            {inventoryItem && (
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                  {' '}
                  تعداد:
                </div>
                <Select
                  open={openSize}
                  onClose={handleCloseSelect}
                  className={classes.showCount}
                  onOpen={() => setOpenSize(true)}
                  value={filtersValues.size}
                  onChange={handleChangeSizePage}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            )}
          </Grid>
          <Grid sm={6}>

            {inventoryItem && (
              <>
                <Pagination
                  count={Math.ceil(inventoryItemsCount / filtersValues.size)}
                  color="secondary"
                  page={filtersValues.page + 1}
                  onChange={handleChangePage}
                />
              </>
            )}
          </Grid>

        </Grid>

      </Grid>
      <Grid
        container
        lg={12}
        md={12}
        xs={12}
        className={classes.btnBottom}
      >
        <Grid
          container
          style={{
            justifyContent: 'center',
          }}
        >

          <Button
            fullWidth
            aria-label="register-parcel"
            onClick={getInventoryItemsWithStatus}
            variant="contained"
            color="primary"
            size="medium"
          >
            <span className="">{'تایید جایگذاری محموله'}</span>
          </Button>
        </Grid>
      </Grid>



      <Dialog
        fullWidth
        open={openRegisterItems}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={.8} />
              </IconButton>
            ) : null}
          </div>

          <div style={{ width: '80%', marginBottom: '30px' }}>
            <Grid>
              <TextField
                fullWidth
                autoFocus
                id="unit"
                name="unit"
                label="واحد"
                value={unit}
                onChange={e => setUnit(e.target.value)}
                inputRef={register({ required: true })}
                error={errors.unit && true}
              />
            </Grid>
          </div>
          <div>
            <div>
              {` از
            تغییر وضعیت کالا با شناسه
            "${id}"
            به
             "${product.status === 'REGISTERED' ? 'جایگذاری شده' : 'تطبیق شده'}"
          مطمئن هستید؟`}
            </div>
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>

              <Button
                onClick={handleAllocateUserFunc}
                fullWidth
                variant="contained"
                disabled={!unit}
                size="medium"
              >
                {'بله'}
              </Button>
            </Grid>

            <Grid item xs={6}>
              <Button
                fullWidth
                onClick={handleClose}
                variant="outlined"
                color="primary"
                size="medium"
              >
                {'خیر'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openDialogForChangeParcelStatus}
        onClose={handleCloseDialogForChangeParcelStatus}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {handleCloseDialogForChangeParcelStatus ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDialogForChangeParcelStatus}
              >
                <Icon path={mdiClose} size={.8} />
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {` از 
            تغییر وضعیت محموله به جایگذاری شده
          مطمئن هستید؟`}
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseDialogForChangeParcelStatus}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>

            <Grid item xs={6}>
              <Button
                onClick={e => handleSetParcelStatus('LOCATED')}
                fullWidth
                variant="contained"
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={openItemHasAlreadyLocated}
        onClose={handleCloseItemHasAlreadyLocated}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {handleCloseItemHasAlreadyLocated ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseItemHasAlreadyLocated}
              >
                <Icon path={mdiClose} size={.8} />
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {`آیتم با سریال
            "${inventoryItemsWithSerial[0]?.serialNumber}"
              قبلا جایگذاری شده است`}
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          <Grid container spacing={1} justify="flex-end">
            <Grid item xs={4}>
              <Button
                onClick={handleCloseItemHasAlreadyLocated}
                fullWidth
                variant="contained"
                size="large"
              >
                {'بستن'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={openDialogForItemsNotRegistered}
        onClose={handleCloseDialogForItemsNotRegistered}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {handleCloseDialogForItemsNotRegistered ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDialogForItemsNotRegistered}
              >
                <Icon path={mdiClose} size={.8} />
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {inventoryItemsWithStatus.length > 1 ? (
              <div>
                {`تعداد 
                "${inventoryItemsWithStatus.length}"
                آیتم از کالاها
                مانند آیتم با مشخصات 
              "${'نام کالا'} : ${inventoryItemsWithStatus[0]?.productName
                  }  - ${'شناسه کالا'} : ${inventoryItemsWithStatus[0]?.productId
                  }"
              هنوز جایگذاری داده نشده است.`}
              </div>
            ) : (
              <div>
                <p>

                  آیتم های زیر جایگذاری نشده اند:
                </p>
                {inventoryItem?.filter((el: InventoryItem) => (el.status !== 'LOCATED' && el.status !== 'CHECKED' && el.status !== 'PICKED'))?.map((el: any, i: number) =>
                  <span>{i !== 0 && ','} {el.id} </span>)}
              </div>
            )}
            <div>
              <Grid style={{ marginTop: '16px', marginBottom: '-8px' }}>
                <TextField
                  variant='outlined'
                  size='small'
                  fullWidth
                  id="description"
                  name="description"
                  autoFocus
                  rows={3}
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  label="توضیحات"
                />
              </Grid>
            </div>
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseDialogForItemsNotRegistered}
                variant="contained"
                color="primary"
                size="medium"
              >
                {'بررسی مجدد'}
              </Button>
            </Grid>

            <Grid item xs={6}>
              <Button
                onClick={e => handleSetParcelStatus('CONFLICTED')}
                fullWidth
                variant="outlined"
                color="primary"

                size="medium"
              >
                {'ایجاد مغایرت'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openLocatingItems}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={.8} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.green.main} />
          </div>
          <div style={{ width: '80%', marginBottom: '30px' }}>
            <Grid>
              <TextField
                fullWidth
                autoFocus
                id="unitItems"
                name="unitItems"
                label="واحد"
                value={unit}
                onChange={e => setUnit(e.target.value)}
                inputRef={register({ required: true })}
                error={errors.unit && true}
              />
            </Grid>
          </div>
          <div>
            {id !== -1 || inventoryItemsWithSerial.length === 0 ? (
              <div>
                {` از
            تغییر وضعیت کالا با شناسه
            "${id}"
            به
            جایگذاری شده
          مطمئن هستید؟`}
              </div>
            ) : (
              <div>
                <Grid
                  style={{ marginBottom: '15px' }}
                  container
                  alignItems="center"
                >
                  {`تعداد
            "${inventoryItems.length}"
           آیتم انتخاب شده است`}
                </Grid>
                <div className={classes.cancelTitle}>
                  {` از
            تغییر وضعیت کالاها
            به
            "${inventoryItemsWithSerial[0]?.status === 'REGISTERED'
                      ? 'جایگذاری شده'
                      : 'تطبیق شده'
                    }"
          مطمئن هستید؟`}
                </div>
              </div>
            )}
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>

              <Button
                onClick={handleAllocateAllItemsUserFunc}
                fullWidth
                variant="contained"
                size="medium"
                disabled={!unit}
                color="primary"

              >
                {'بله'}
              </Button>
            </Grid>

            <Grid item xs={6}>
              <Button
                fullWidth
                onClick={handleClose}
                variant="outlined"
                color="primary"
                size="medium"
              >
                {'خیر'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openItemsNotFound}
        onClose={handleCloseItemsNotFound}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {handleCloseItemsNotFound ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseItemsNotFound}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {`آیتم مورد نظر با بارکد 
            " ${barcode} "
            یافت نشد.`}
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          <Grid container justify="flex-end">
            <Button
              autoFocus
              onClick={handleCloseItemsNotFound}
              variant="contained"
              color="primary"
              size="large"
            >
              {'باشه'}
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
      <Modal
        maxWidth="lg"
        onClose={() => handleCloseBarcode(false)}
        open={openBarcode}
        title={
          <Grid container justify="center">

          </Grid>
        }
        content={
          <form onSubmit={handleSubmit(checkSerialFunc)}>
            <Grid container style={{ marginBottom: '0', paddingBottom: 0 }}>
              <Grid item xs={12}>
                <p style={{ fontSize: '12px' }}>{'سریال یونیت  را وارد کنید'}</p>
              </Grid>
              <Grid xs={12}>
                <div style={{ width: '100%', marginBottom: '30px' }}>
                  <TextField
                    variant='outlined'
                    fullWidth
                    autoFocus
                    id="serial"
                    name="serial"
                    label="سریال"
                    size='small'
                    inputRef={register({ required: true })}
                    InputProps={{
                      startAdornment: <Icon path={mdiBarcodeScan} size={1} color="gray" />,
                    }}
                  />
                </div>
                <FormHelperText error focused>
                  {errors.serial && 'سریال یونیت الزامی میباشد'}
                </FormHelperText>
              </Grid>
              <Divider style={{ width: '100%', marginBottom: '8px' }} />
              <Grid xs={12} container justify="center" style={{ marginBottom: '-16px' }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  fullWidth
                  type="submit"
                  disabled={watch('serial')?.length === 0}
                >
                  {'تایید'}
                </Button>
              </Grid>
            </Grid>
          </form>
        }
      />
      <Modal
        fullScreen
        onClose={() => {
          setOpenBarcodeSerial(false)
          setInventoryItems([])
        }}
        open={openBarcodeSerial}
        title={
          <Grid container justify="center">
            {/* <Icon
              path={mdiPackageVariantClosed}
              size={4}
              color={theme.palette.green.main}
            /> */}
            <h2 style={{textAlign: "center", marginTop: "20px"}}>جایگذاری کالاهای محموله {props.match.params.id}</h2>
          </Grid>
        }
        content={
          <Grid container>
            <BarcodeForm
              id={props.match.params.id}
              inventoryItemsWithSerial={inventoryItemsWithSerial}
              getInventoryItemsWithSerialActionDispatch={
                getInventoryItemsWithSerial
              }
              inventoryItemsWithSerialLoading={
                inventoryItemsWithSerialLoading
              }
              setModal={setOpenBarcodeSerial}
            />
            <div style={{ margin: '0 20px' }}>
              <span>{'تعداد : '}</span>
              <span>{inventoryItems.length}</span>
            </div>
            {inventoryItems.length !== 0 ? (
              <>
                <Grid
                  container
                  style={{
                    marginTop: '30px',
                    marginBottom: '30px',
                    // maxHeight: '400px',
                    // overflowY: 'scroll',
                  }}
                >
                  <InventoryItemsList
                    operatorId={parcel.operatorId}
                    removeItem={(item: any) => removeItem(item)}
                    data={inventoryItems}
                  />
                </Grid>
              </>
            ) : null}
          </Grid>
        }
        actions={
          <Button
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            // startIcon={<Icon path={mdiFileTree} size={1} />}
            onClick={checkBarcode}
          >
            {'جایگذاری کالا ها'}
          </Button>
        }
      />
    </div>
  );
}

export type Inputs = {
  barcodeSerial: string;
};

function BarcodeForm(props: any) {
  const { handleSubmit, register, getValues, setValue, watch, errors } = useForm<Inputs>();

  useEffect(() => {
    if (props.inventoryItemsWithSerial.length !== 0) {
      setValue('barcodeSerial', '');
    }
  }, [props.inventoryItemsWithSerial])

  const checkBarcodeFunc = (data: any) => {
    props.getInventoryItemsWithSerialActionDispatch({
      serialNumber: { equals: data.barcodeSerial },
      parcelId: { equals: props.id }
    });
    props.setModal(true)
  };

  return (
    <form
      style={{ width: '100%' }}
      onSubmit={handleSubmit(checkBarcodeFunc)}
    >
      <Grid container>
        <Grid xs={12}>
          <div style={{ width: '100%', marginBottom: '8px' }}>
            <TextField
              style={{ backgroundColor: 'white' }}
              size='small'
              variant='outlined'
              fullWidth
              autoFocus
              id="barcodeSerial"
              name="barcodeSerial"
              label=" چک کردن بارکد"
              InputProps={{
                startAdornment: <Icon path={mdiBarcodeScan} size={1} color="gray" />,
                readOnly: props.inventoryItemsWithSerialLoading
              }}
              inputRef={register({ required: true })}

            />
          </div>
        </Grid>

      </Grid>
    </form>
  )
}


// @ts-ignore
export default Details;
